import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { toast, Loader } from '@grandvisionhq/common';
import { useIsClient } from '@grandvisionhq/lib-utils-react';
import { useIntl } from '@grandvisionhq/state';
import { validationErrorLabelMap } from '../../utils/get-validation-error-codes.js';
import { mapLineItemToDataLayerEvent } from '../../mappers/analytics/data-layer/line-item-to-data-layer-event.js';
import { EmptyCartContainer } from '../EmptyCart/containers/EmptyCartContainer.js';
import { Cart as Cart$1 } from './components/Cart.js';
import { useCart } from '../../context/Cart/context.js';
import { useCartSettings } from '../../context/CartSettings/context.js';

const Cart = ({ onEmptyCartButtonClick , policyItems , donation  })=>{
    const { cart , loading , error  } = useCart();
    const settings = useCartSettings();
    const intl = useIntl();
    const cartExists = Boolean(cart);
    const isClient = useIsClient();
    const labels = React.useMemo(()=>({
            cartTitle: intl.getLabel('cart.title'),
            unavailableTitle: intl.getLabel('cart.unavailableItems.title')
        })
    , [
        intl
    ]);
    React.useEffect(()=>{
        if (cart === null || cart === void 0 ? void 0 : cart.validationErrors) {
            const errorCodes1 = Object.entries(cart.validationErrors).flatMap(([, errorCodes])=>{
                return errorCodes.map((code)=>validationErrorLabelMap[code]
                );
            });
            new Set(errorCodes1).forEach((code)=>{
                toast.failed(`cart.${code}`);
            });
        }
    }, [
        cart === null || cart === void 0 ? void 0 : cart.validationErrors
    ]);
    const handleCheckoutNavigation = React.useCallback(()=>{
        if (!(cart === null || cart === void 0 ? void 0 : cart.id) || !(cart === null || cart === void 0 ? void 0 : cart.lineItems.length)) return;
        const dataLayerEvents = mapLineItemToDataLayerEvent(DataLayer.DataLayerTypes.EventType.checkout, (cart === null || cart === void 0 ? void 0 : cart.lineItems) || [], (cart === null || cart === void 0 ? void 0 : cart.id) || '');
        dataLayerEvents && DataLayer.pushEcommerceEvent(dataLayerEvents);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.id,
        cart === null || cart === void 0 ? void 0 : cart.lineItems
    ]);
    if (!isClient) {
        return null;
    }
    if (loading) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "cart",
            "data-t": "loading-cart"
        }, /*#__PURE__*/ React.createElement(Loader, null));
    }
    const lineItems = (cart === null || cart === void 0 ? void 0 : cart.lineItems.filter((lineItem)=>{
        var ref;
        return !(cart === null || cart === void 0 ? void 0 : (ref = cart.validationErrors) === null || ref === void 0 ? void 0 : ref[lineItem.id]);
    })) || [];
    const unavailableLineItems = (cart === null || cart === void 0 ? void 0 : cart.lineItems.filter((lineItem)=>{
        var ref;
        return cart === null || cart === void 0 ? void 0 : (ref = cart.validationErrors) === null || ref === void 0 ? void 0 : ref[lineItem.id];
    })) || [];
    const cartEmpty = lineItems.length < 1 && unavailableLineItems.length < 1;
    const deliveryResolver = settings.deliveryResolverFactory && settings.deliveryResolverFactory(lineItems);
    const visualLineItems = (cart === null || cart === void 0 ? void 0 : cart.visualLineItems) || [];
    const availableVisualLineItems = visualLineItems.filter((visualLineItem)=>{
        return lineItems.some((lineItem)=>lineItem.id === visualLineItem.id
        );
    });
    if (!cartExists || error || cartEmpty) {
        return /*#__PURE__*/ React.createElement(EmptyCartContainer, {
            onClick: onEmptyCartButtonClick
        });
    }
    return cart ? /*#__PURE__*/ React.createElement(Cart$1, {
        cartId: cart.id,
        hasSubscription: Boolean(cart === null || cart === void 0 ? void 0 : cart.hasSubscription),
        labels: labels,
        lineItems: lineItems,
        visualLineItems: availableVisualLineItems,
        unavailableLineItems: unavailableLineItems,
        readOnly: settings.readOnly,
        deliveryResolver: deliveryResolver,
        policyItems: policyItems,
        handleCheckoutNavigation: handleCheckoutNavigation,
        donation: donation
    }) : null;
};

export { Cart };
//# sourceMappingURL=Cart.js.map
